import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	isShowAside: true,
};

const layoutSlice = createSlice({
	name: "layoutSlice",
	initialState,
	reducers: {
		navShowHide: (state, { payload }) => {
			state.isShowAside = !state.isShowAside;
		},
	},
});

export default layoutSlice.reducer;
export const { navShowHide } = layoutSlice.actions;
